module.exports = __webpack_public_path__ + "static/node2-521444a28d1ac7003ece0c1f030dcd21.png";